import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import Image from "components/image";
import RichText from "components/rich-text";
import Link from "helpers/link";
import Button from "components/button";
import { formatTitle } from "helpers/format-title";

const Slider = (props) => {
	const { content = {}, data = [], button = {}, leftAlign, showDots } = props.data;

	const settings = {
		slidesPerView: 1.1,
		preventClicks: true,
		preventClicksPropagation: false,
		noSwiping: true,
		freeMode: true,
		pagination: showDots ? showDots : false,
		spaceBetween: 20,
		dots: showDots ? `${showDots}` : "",
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
		breakpoints: {
			1024: {
				preventClicks: true,
				preventClicksPropagation: false,
				noSwiping: true,
				freeMode: true,
				simulateTouch: true,
				spaceBetween: 30,
				slidesPerView: 4,
				slidesPerGroup: 2,
			},
			768: {
				preventClicks: true,
				preventClicksPropagation: true,
				noSwiping: true,
				freeMode: true,
				simulateTouch: true,
				spaceBetween: 30,
				slidesPerView: 2.5,
				slidesPerGroup: 1,
			},
			550: {
				preventClicks: true,
				preventClicksPropagation: true,
				noSwiping: true,
				freeMode: true,
				simulateTouch: true,
				spaceBetween: 30,
				slidesPerView: 1.5,
				slidesPerGroup: 1,
			},
		},
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-ss",
			prevEl: ".left-arrow-ss",
		},
		a11y: true,
	};

	return (
		<div className="lg:my-20 w-11/12 lg:w-4/5 m-auto hd-screen-max-width">
			<div className={`${leftAlign ? "text-left" : "text-center"} mb-10`}>
				<RichText value={content} />
			</div>
			<div className="relative">
				{
					<Swiper {...settings} className={data?.length < 5 ? "products-slider" : ""}>
						{data.map((slide, i) => (
							<SwiperSlide key={i} className={`p-2  border-gray-50 cursor-pointer`}>
								<Link tabIndex={0} className="block border-focus-ay11" to={slide.url}>
									<Image role="presentation" className="w-full" image={slide.image} alt={slide.image?.alt} />
									<p className="text-center p-1 font-body md:p-3 font-medium text-lg md:text-base">
										{formatTitle(slide.title)}
									</p>
								</Link>
							</SwiperSlide>
						))}
					</Swiper>
				}
				<div className="left-arrow-ss md:-left-20 -left-9 md:flex hidden">
					<LeftArrow role="presentation" aria-hidden="true" />
				</div>
				<div className="right-arrow-ss md:-right-20 -right-9 md:flex hidden">
					<RightArrow role="presentation" aria-hidden="true" />
				</div>
			</div>
			<Button data={button} className="md:mt-10 mt-4 btn-center" />
		</div>
	);
};

export default Slider;